import firebaseConfig from "../config/firebase";
import firebase from "firebase/app";
import "firebase/storage";

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };
